(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-categories"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = (root = document) => {
  if (window.AOD?.stage) root.querySelectorAll('[data-home-categories]').forEach(el => AOD.stage.renderStaticStages(el));
 };
 document.addEventListener('DOMContentLoaded', () => init());
 document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var slides = [].slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-hero-dot]'));
    if (slides.length < 2 || root.__aodHero) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ms = Math.max(4, parseInt(root.getAttribute('data-interval'), 10) || 7) * 1000;
    root.style.setProperty('--aod-hero-dur', (ms / 1000 + 2) + 's');
    var i = 0, timer;
    function show(n) {
      var prev = slides[i];
      prev.classList.remove('is-active'); prev.classList.add('is-leaving'); prev.setAttribute('aria-hidden', 'true');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 1500);
      i = n;
      var cur = slides[i];
      cur.classList.remove('is-leaving'); void cur.offsetWidth; cur.classList.add('is-active'); cur.removeAttribute('aria-hidden');
      dots.forEach(function (d, k) { d.firstElementChild.classList.toggle('is-active', k === i); });
    }
    function start() { if (reduce || timer) return; timer = setInterval(function () { show((i + 1) % slides.length); }, ms); }
    function stop() { clearInterval(timer); timer = null; }
    // Manual control: go to a slide, then restart the auto-advance clock so the next auto change is a full interval away.
    function go(n) { n = (n + slides.length) % slides.length; if (n === i) return; show(n); stop(); start(); }
    var prevBtn = root.querySelector('[data-hero-prev]'), nextBtn = root.querySelector('[data-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(i - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(i - 1); else if (e.key === 'ArrowRight') go(i + 1); });
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) { root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start); }
    var sx = null, sy = 0;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    root.__aodHero = { start: start, stop: stop };
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }
  function boot() { document.querySelectorAll('[data-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-live-designer"] && !Shopify.designMode) return;
  try {
    
(() => {
 function init(root = document) {
  root.querySelectorAll('[data-live-designer]').forEach(el => {
   if (el.dataset.initialized || !window.AOD?.stage || !AOD.catalog) return;
   el.dataset.initialized = 'true';
   const { garmentColors, fonts, threads } = AOD.catalog;
   const d = { garment: 'crew', color: el.dataset.defaultColor || 'cream', mode: 'text', text: el.querySelector('[data-try-text]').value, font: el.dataset.defaultFont || 'signature', thread: el.dataset.defaultThread || 'T13', placement: 'center', style: 'straight', size: 0.9, dx: 0, dy: 0, removeBg: true, sleeve: false, sleeveText: '' };
   const stage = el.querySelector('[data-try-stage]');
   function draw() {
    AOD.stage.renderStage(stage, { ...d }).catch(() => {});
    const link = new URL(el.dataset.productUrl, window.location.origin);
    ['text', 'font', 'color', 'thread'].forEach(key => link.searchParams.set(key, d[key]));
    el.querySelector('[data-try-go]').href = link.href;
   }
   function buttons(selector, values, key, labelSelector) {
    const box = el.querySelector(selector);
    values.forEach(item => {
     const button = document.createElement('button');
     button.type = 'button';
     button.className = key === 'font' ? 'pill h-12 text-[17px] truncate' : 'sw';
     const value = key === 'thread' ? item.code : item.id;
     button.setAttribute('aria-label', item.label || item.name);
     button.setAttribute('aria-pressed', String(value === d[key]));
     if (key === 'font') { button.textContent = item.label; button.style.fontFamily = item.family; button.style.fontWeight = item.weight; }
     else button.style.background = item.metallic ? `linear-gradient(135deg,${item.hex},#fff6d8,${item.hex})` : item.hex;
     button.addEventListener('click', () => {
      box.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      d[key] = value;
      if (labelSelector) el.querySelector(labelSelector).textContent = item.name;
      draw();
     });
     box.append(button);
    });
   }
   buttons('[data-try-fonts]', ['script', 'signature', 'varsity', 'serif', 'rounded', 'retro'].map(id => fonts.find(f => f.id === id)).filter(Boolean), 'font');
   buttons('[data-try-colors]', ['cream', 'sage', 'lavender', 'lightpink', 'carolina', 'sand', 'navy', 'black'].map(id => ({ id, ...garmentColors[id] })), 'color', '[data-try-color-name]');
   buttons('[data-try-threads]', ['1967', '1108', '1037', '1297', '1033', '1801', '1800', '1103'].map(code => threads.find(t => t.code === code)).filter(Boolean), 'thread', '[data-try-thread-name]');
   el.querySelector('[data-try-text]').addEventListener('input', event => { d.text = event.target.value; draw(); });
   el.querySelector('[data-try-color-name]').textContent = garmentColors[d.color].name;
   el.querySelector('[data-try-thread-name]').textContent = AOD.stage.threadOf(d.thread).name;
   draw();
   if (document.fonts) document.fonts.ready.then(draw);
  });
 }
 document.addEventListener('DOMContentLoaded', () => init());
 document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-row"] && !Shopify.designMode) return;
  try {
    
(() => {
 function init(root = document) {
  root.querySelectorAll('[data-product-row]').forEach(el => {
   if (el.dataset.initialized) return;
   el.dataset.initialized = 'true';
   const rail = el.querySelector('[data-rail]');
   [-1, 1].forEach(direction => el.querySelector(direction < 0 ? '[data-rail-prev]' : '[data-rail-next]').addEventListener('click', () => {
    const width = rail.firstElementChild?.getBoundingClientRect().width || 300;
    rail.scrollBy({ left: direction * (width + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
   }));
  });
 }
 document.addEventListener('DOMContentLoaded', () => init());
 document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-vid-src]').forEach(function (v) {
      if (v.__aodVid) return; v.__aodVid = true;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!v.src) v.src = v.getAttribute('data-vid-src');
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: 0.4 });
      io.observe(v);
    });
  }
  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-cart-page]').forEach(el => {
      if (el.dataset.initialized || !window.AOD?.cart) return;
      el.dataset.initialized = 'true';
      const box = el.querySelector('[data-page-lines]');
      const summary = el.querySelector('[data-page-summary]');
      const status = el.querySelector('[data-cart-status]');
      const money = cents => AOD.money(Math.round(cents));
      const route = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      let busy = false;
      let currentCart;
      function node(tag, classes, text) {
        const element = document.createElement(tag);
        if (classes) element.className = classes;
        if (text !== undefined) element.textContent = String(text);
        return element;
      }
      function link(text, url, classes) {
        const element = node('a', classes, text);
        element.href = url;
        return element;
      }
      function property(dl, key, value) {
        const row = node('div', 'flex gap-2 min-w-0');
        row.append(node('dt', 'text-mute shrink-0', key), node('dd', 'truncate', value));
        dl.append(row);
      }
      function image(stage, url, title) {
        if (!url) return;
        try {
          const src = new URL(url, location.origin);
          if (!['https:', 'http:'].includes(src.protocol)) return;
          const img = node('img', 'w-full h-full object-contain');
          img.src = src.href; img.alt = title; img.loading = 'lazy';
          img.width = 500; img.height = 500;
          stage.append(img);
        } catch (_) { /* Keep the product link usable without media. */ }
      }
      function action(key, quantity, label, classes) {
        const form = node('form');
        form.action = route + 'cart'; form.method = 'post';
        form.dataset.cartUpdate = ''; form.dataset.key = key; form.dataset.quantity = quantity;
        const input = node('input');
        input.type = 'hidden'; input.name = `updates[${key}]`; input.value = quantity;
        const button = node('button', classes, label);
        button.type = 'submit'; button.name = 'update';
        button.disabled = busy || quantity > 500;
        button.setAttribute('aria-label', label === '−' ? 'Decrease quantity' : label === '+' ? 'Increase quantity' : 'Remove item');
        form.append(input, button);
        return form;
      }
      function draw(cart) {
        if (!cart || !el.isConnected) return;
        currentCart = cart;
        const all = AOD.cart.lines(cart);
        const lines = all.filter(line => !line.isFee);
        const fees = all.filter(line => line.isFee);
        const assigned = new Set();
        const totals = AOD.cart.totals(cart);
        summary.hidden = !lines.length;
        el.querySelector('[data-p-sub]').textContent = money(totals.subtotal * 100);
        el.querySelector('[data-p-ship]').textContent = totals.toFree <= 0 ? 'Free' : 'Calculated at checkout';
        const threshold = totals.subtotal + totals.toFree;
        el.querySelector('[data-p-bar]').style.width = `${threshold > 0 ? Math.min(100, totals.subtotal / threshold * 100) : 100}%`;
        el.querySelector('[data-p-ship-text]').textContent = totals.toFree <= 0 ? 'Free U.S. shipping unlocked.' : `Add ${money(totals.toFree * 100)} for free U.S. shipping.`;
        summary.querySelectorAll('[data-cart-discount]').forEach(discount => discount.remove());
        (cart.cart_level_discount_applications || []).forEach(discount => {
          const p = node('p', 'text-[12px] text-mute mt-2', `${discount.title} (−${money(discount.total_allocated_amount)})`);
          p.dataset.cartDiscount = '';
          el.querySelector('[data-p-ship-text]').after(p);
        });
        if (!lines.length) {
          box.replaceChildren(el.querySelector('[data-cart-empty]').content.cloneNode(true));
          return;
        }
        const rows = document.createDocumentFragment();
        lines.forEach(line => {
          const row = node('div', 'py-6 border-b border-line grid grid-cols-[120px_1fr] sm:grid-cols-[180px_1fr] gap-5');
          row.dataset.line = line.key;
          const url = route + 'products/' + encodeURIComponent(line.handle || '');
          const editURL = url + '?edit=' + encodeURIComponent(line.key);
          const preview = link('', line.design ? editURL : url, 'bg-cream self-start');
          preview.setAttribute('aria-label', line.title);
          const stage = node('div');
          image(stage, line.image, line.title); preview.append(stage);
          const content = node('div', 'min-w-0');
          const header = node('div', 'flex flex-wrap justify-between gap-4');
          const heading = node('div');
          heading.append(link(line.title, line.design ? editURL : url, 'text-[16px] font-medium'), node('p', 'text-[13px] text-mute mt-0.5', [line.variantTitle, `${money(line.unitPrice)} each`].filter(Boolean).join(' · ')));
          header.append(heading, node('span', 'text-[15px]', money(line.linePrice)));
          const dl = node('dl', 'mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-1 text-[13px]');
          Object.entries(line.properties || {}).filter(([key, value]) => !key.startsWith('_') && value !== '').forEach(([key, value]) => property(dl, key, value));
          const did = line.properties?._did;
          if (did && !assigned.has(did)) {
            fees.filter(fee => fee.properties?._fee_for === did).forEach(fee => property(dl, fee.properties.Fee || 'Add-ons', money(fee.linePrice)));
            assigned.add(did);
          }
          const controls = node('div', 'mt-4 flex flex-wrap items-center gap-4');
          const quantity = node('div', 'flex items-center border border-line rounded-sm h-9');
          quantity.append(action(line.key, line.quantity - 1, '−', 'w-9 h-9'), node('span', 'w-8 text-center text-[13px]', line.quantity), action(line.key, line.quantity + 1, '+', 'w-9 h-9'));
          controls.append(quantity);
          if (line.design) controls.append(link('Edit design', editURL, 'text-[13px] link-u'));
          controls.append(action(line.key, 0, 'Remove', 'text-[13px] text-mute link-u'));
          content.append(header, dl);
          const raw = (cart.items || []).find(item => item.key === line.key);
          (raw?.line_level_discount_allocations || []).forEach(discount => {
            content.append(node('p', 'text-[12px] text-mute mt-2', `${discount.discount_application.title} (−${money(discount.amount)})`));
          });
          content.append(controls); row.append(preview, content); rows.append(row);
          if (line.design && window.AOD?.stage) {
            AOD.stage.renderStage(stage, line.design).catch(() => { stage.replaceChildren(); image(stage, line.image, line.title); });
          }
        });
        box.replaceChildren(rows);
      }
      el.addEventListener('submit', async event => {
        const form = event.target.closest('[data-cart-update]');
        if (!form) return;
        event.preventDefault();
        if (busy) return;
        busy = true; status.textContent = 'Updating your bag…';
        box.setAttribute('aria-busy', 'true');
        box.querySelectorAll('button').forEach(button => { button.disabled = true; });
        summary.querySelector('[name="checkout"]').disabled = true;
        try {
          const key = form.dataset.key;
          const quantity = Number(form.dataset.quantity);
          const cart = quantity === 0 ? await AOD.cart.remove(key) : await AOD.cart.setQty(key, quantity);
          currentCart = cart;
          status.textContent = 'Your bag is up to date.';
        } catch (error) {
          status.textContent = error.message || 'Your bag could not be updated. Please try again.';
        } finally {
          busy = false; box.removeAttribute('aria-busy');
          summary.querySelector('[name="checkout"]').disabled = false;
          if (currentCart) draw(currentCart);
          else box.querySelectorAll('button').forEach(button => { button.disabled = false; });
        }
      });
      const change = event => {
        if (!el.isConnected) { window.removeEventListener('cart:change', change); return; }
        draw(event.detail);
      };
      window.addEventListener('cart:change', change);
      AOD.cart.get().then(draw).catch(() => { /* Native forms remain available. */ });
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => root.querySelectorAll('[data-collection-filters]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    form.addEventListener('change', event => { if (event.target.matches('input, select')) form.requestSubmit(); });
    form.querySelector('[data-apply]')?.setAttribute('hidden', '');
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-simple"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var el = root.querySelector('[data-simple-product]');
    if (!el || el.__simple) return;
    el.__simple = true;
    var variants = JSON.parse(el.querySelector('[data-simple-variants]').textContent);
    var form = el.querySelector('[data-simple-form]');
    var idInput = el.querySelector('[data-simple-id]');
    var priceEl = el.querySelector('[data-simple-price]');
    var status = el.querySelector('[data-simple-status]');
    var qty = el.querySelector('[data-simple-qty]');
    var addBtn = el.querySelector('[data-simple-add]');
    var groups = {};
    el.querySelectorAll('[data-simple-option]').forEach(function (b) { (groups[b.dataset.simpleOption] = groups[b.dataset.simpleOption] || []).push(b); });
    var chosen = {};
    Object.keys(groups).forEach(function (k) { var on = groups[k].filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || groups[k][0]; chosen[k] = on.dataset.value; });
    function money(c) { return window.AOD && AOD.money ? AOD.money(c) : '$' + (c / 100).toFixed(2); }
    function current() {
      return variants.filter(function (v) { return Object.keys(chosen).every(function (k) { return v.options[Number(k)] === chosen[k]; }); })[0];
    }
    function sync() {
      var v = current();
      Object.keys(groups).forEach(function (k) {
        groups[k].forEach(function (b) { var on = b.dataset.value === chosen[k]; b.setAttribute('aria-checked', on); b.setAttribute('aria-pressed', on); });
        var note = el.querySelector('[data-simple-chosen="' + k + '"]'); if (note) note.textContent = '— ' + chosen[k];
      });
      if (v) {
        idInput.value = v.id;
        priceEl.textContent = v.price === 0 ? 'Pricing coming soon' : money(v.price);
        addBtn.disabled = false; status.textContent = '';
      } else { addBtn.disabled = true; status.textContent = 'This combination is not available.'; }
    }
    Object.keys(groups).forEach(function (k) { groups[k].forEach(function (b) { b.addEventListener('click', function () { chosen[k] = b.dataset.value; sync(); }); }); });
    el.querySelectorAll('[data-simple-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = el.querySelector('[data-simple-main]'); if (main) { main.removeAttribute('srcset'); main.src = t.dataset.simpleThumb; }
        el.querySelectorAll('[data-simple-thumb]').forEach(function (o) { var on = o === t; o.setAttribute('aria-pressed', on); o.classList.toggle('outline-ink', on); o.classList.toggle('outline-transparent', !on); });
      });
    });
    function step(d) { qty.value = Math.max(1, Math.min(99, (parseInt(qty.value, 10) || 1) + d)); }
    el.querySelector('[data-simple-dec]').addEventListener('click', function () { step(-1); });
    el.querySelector('[data-simple-inc]').addEventListener('click', function () { step(1); });
    form.addEventListener('submit', function (e) {
      if (!window.AOD || !AOD.cart || !AOD.cart.add) return;
      e.preventDefault();
      var v = current(); if (!v) return;
      var props = {};
      var text = el.querySelector('[data-simple-text]');
      if (text) { if (!text.value.trim()) { status.textContent = 'Please tell us what to embroider.'; text.focus(); return; } props.Personalization = text.value.trim(); }
      addBtn.disabled = true; addBtn.textContent = 'Adding…'; status.textContent = '';
      AOD.cart.add([{ id: v.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1), properties: props }]).then(function () {
        if (AOD.ui) { AOD.ui.openDrawer(); AOD.ui.toast('Added to your bag.'); }
      }).catch(function () { status.textContent = 'Could not add to the bag. Please try again.'; }).then(function () { addBtn.disabled = false; addBtn.textContent = 'Add to bag'; });
    });
    sync();
  }
  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
